<script context="module">
  export interface ITreeNavigationItem {
    id: number;
    isActive: boolean;
    level: number;
    parentId: number;
    sortOrder: number;
    title: string;
    url: string;
    children: ITreeNavigationItem[];
  }
</script>

<script>
  import UserInformation from "../../user/UserInformation.svelte";
  import MainLevel from "./MainLevel.svelte";

  const navigation: Promise<ITreeNavigationItem[]> = fetch(
    `/api/LindOgRisorNavigation/getMobileTopNavigation`
  ).then((r) => r.json());
</script>

<div class="main-menu g-centered">
  {#await navigation then nav}
    <div class="main-menu-list">
      {#each nav as { url, title, children }}
        <MainLevel {url} {title} {children} on:click />
      {/each}
    </div>
  {/await}

  <UserInformation on:click />
</div>

<style lang="scss">
  .main-menu {
    padding-top: 36px;
    padding-bottom: 37px;
  }

  .main-menu-list {
    margin-bottom: 25px;
  }
</style>
